import { call, put, takeLatest } from 'redux-saga/effects';
import * as progressApi from '../api/progressApi.js';
import {
  detailedReportFailed,
  detailedReportRequested,
  detailedReportSucceeded,
  proficiencyFailed,
  proficiencyLoaded,
  proficiencyRequested,
} from './progressSlice.js';
import { normalizeProficiency } from '../lib/proficiencyModel.js';
import { captureSagaError } from '../../../lib/sentry.js';
import { friendlyErrorMessage } from '../../../lib/errorCopy.js';
import { toastShown } from '../../system/store/toastSlice.js';
import { openInAppBrowser } from '../../../services/native/inAppBrowserService.js';

function openDetailedReportOnWeb(url) {
  window.open(url, '_blank', 'noopener,noreferrer');
}

export function* handleFetchProficiency() {
  try {
    const res = yield call(progressApi.fetchMyStep);
    if (res && res.status && res.code === 200) {
      yield put(proficiencyLoaded(normalizeProficiency(res.data)));
    } else {
      yield put(proficiencyFailed(res?.message || 'Failed to load score report'));
    }
  } catch (err) {
    captureSagaError(err, { action: 'progress/proficiencyRequested' });
    yield put(proficiencyFailed(friendlyErrorMessage(err, 'Failed to load score report')));
  }
}

export function* handleDetailedReport() {
  try {
    const res = yield call(progressApi.fetchDetailedReport);
    if (res && res.status && res.code === 200 && res.data?.file_url) {
      const handledByNativeBrowser = yield call(openInAppBrowser, res.data.file_url);
      if (!handledByNativeBrowser) {
        yield call(openDetailedReportOnWeb, res.data.file_url);
      }
      yield put(detailedReportSucceeded());
    } else {
      const message = res?.message || 'Could not open detailed report';
      yield put(detailedReportFailed(message));
      yield put(toastShown({ variant: 'error', message }));
    }
  } catch (err) {
    captureSagaError(err, { action: 'progress/detailedReportRequested' });
    const message = friendlyErrorMessage(err, 'Could not open detailed report');
    yield put(detailedReportFailed(message));
    yield put(toastShown({ variant: 'error', message }));
  }
}

export default function* progressSaga() {
  yield takeLatest(proficiencyRequested.type, handleFetchProficiency);
  yield takeLatest(detailedReportRequested.type, handleDetailedReport);
}
